<template>
  <v-menu
    v-model="pickerMenu"
    ref="menu"
    :close-on-content-click="false"
    :return-davlue.sync="date"
    transition="scale-transition"
    offset-y
    bottom
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider
        v-slot="{ errors }"
        :name="`field_${_uid}`"
        :rules="rules"
        :custom-messages="{
          required: $t('validation.dateInvalid')
        }"
      >
        <v-text-field
          v-model="formattedDate"
          outlined
          flat
          append-icon="mdi-calendar"
          persistent-hint
          :name="fieldLabel"
          :label="fieldLabel"
          :hint="$t('application.dateFormatInfo')"
          :aria-describedby="hintId"
          :error-messages="errors"
        >
          <template v-slot:message="{ message }">
            <span :id="hintId">
              {{ message }}
            </span>
          </template>
          <template v-slot:append>
            <v-btn
              ref="calendarButton"
              icon
              small
              :aria-label="$t('application.openCalendar')"
              @click="on.click"
            >
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>

    <v-date-picker v-model="date" class="pa-0" first-day-of-week="1">
      <v-spacer></v-spacer>
      <v-btn
        text
        fab
        color="primary"
        @click="pickerMenu = false"
        :title="$t('close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-btn text fab color="primary" @click="$refs.menu.save(date)">
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { extend, ValidationProvider } from 'vee-validate';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: () => ({
    date: null,
    formattedDate: null,
    pickerMenu: false
  }),

  watch: {
    pickerMenu(isOpen) {
      if (isOpen) {
        this.focusCalendar();
      } else {
        this.focusCalendarButton();
      }
    },

    date() {
      const newDate = this.formatDate(this.date);
      if (newDate && this.formattedDate !== newDate) {
        this.formattedDate = newDate;
      }
    },

    formattedDate() {
      if (this.isValidDate(this.formattedDate)) {
        this.$emit('input', this.formattedDate);
      }
    },

    value() {
      this.date = this.getDate(this.value);
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    hintId() {
      return `date-field-hint-${this._uid}`;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'validDate|required';
      }

      return 'validDate';
    }
  },

  created() {
    extend('validDate', {
      validate: this.isValidDate,
      message: this.$t('validation.dateInvalid')
    });
  },

  mounted() {
    if (this.value) {
      this.date = this.getDate(this.value);
    }
  },

  methods: {
    focusCalendar() {
      this.$nextTick(() => {
        const menu = document.querySelector(
          '.v-menu__content.menuable__content__active'
        );

        const picker = menu?.querySelector(
          '.v-date-picker-header__value button'
        );

        window.setTimeout(() => picker?.focus?.(), 100);
      });
    },

    focusCalendarButton() {
      this.$nextTick(() => {
        const button =
          this.$refs.calendarButton?.$el || this.$refs.calendarButton;
        button?.focus?.();
      });
    },

    getDate(formattedDate) {
      if (!formattedDate) {
        return null;
      }

      if (formattedDate.includes('.')) {
        const [day, month, year] = formattedDate.split('.');
        return `${year}-${month}-${day}`;
      } else {
        return formattedDate;
      }
    },

    formatDate(date) {
      if (!date) {
        return '';
      }

      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
      } else if (date.includes('/')) {
        const [month, day, year] = date.split('/');
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
      } else {
        return date;
      }
    },

    isValidDate(formattedDate) {
      const [day, month, year] = formattedDate.split('.');
      if (day && month && year && year > 1000 && year < 3000) {
        const date = `${year}-${month}-${day}`;
        return !isNaN(new Date(date));
      }

      return false;
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
